import { render, staticRenderFns } from "./web-marathon-home.vue?vue&type=template&id=31483180&scoped=true&"
import script from "./web-marathon-home.vue?vue&type=script&lang=js&"
export * from "./web-marathon-home.vue?vue&type=script&lang=js&"
import style0 from "./web-marathon-home.vue?vue&type=style&index=0&id=31483180&lang=scss&scoped=true&"
import style1 from "./web-marathon-home.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31483180",
  null
  
)

export default component.exports